import { extendTailwindMerge } from "tailwind-merge";
const twExtendedConfig = {
  classGroups: {
    "font-size": [
      "text-d1",
      "text-d2",
      "text-h1",
      "text-h2",
      "text-h3",
      "text-h4",
      "text-t1",
      "text-t2",
      "text-t3",
      "text-t4",
      "text-s1",
      "text-s2",
      "text-s3",
      "text-b1",
      "text-b2",
      "text-b3",
      "text-c1",
      "text-c2"
    ]
  },
  conflictingClassGroups: {
    "font-size": ["font-size", "text-color"]
  }
};
const twMerge = extendTailwindMerge({
  extend: {
    ...twExtendedConfig
  }
});
export {
  twExtendedConfig,
  twMerge
};
